export const stylePrefix = 'formily-element'
